import productMarkEnum from './productMark'
import activityStatusEnum from './activityStatus'
import orderStatusEnum from './orderStatus'
import payStatusEnum from './payStatus'
import shippingStatusEnum from './shippingStatus'
import activityBannerStatusEnum from './activityBannerStatus'
import refundStatusEnum from './refundStatus'
import returnStatusEnum from './returnStatus'
import refundTypesEnum from './refundTypes'

import Enum from './enum'
const productMark = new Enum(productMarkEnum);
const activityStatus = new Enum(activityStatusEnum);
const orderStatus = new Enum(orderStatusEnum);
const payStatus = new Enum(payStatusEnum);
const shippingStatus = new Enum(shippingStatusEnum);
const activityBannerStatus = new Enum(activityBannerStatusEnum);
const refundStatus = new Enum(refundStatusEnum)
const returnStatus = new Enum(returnStatusEnum)
const refundTypes = new Enum(refundTypesEnum)

export default {
  productMark,
  activityStatus,
  orderStatus,
  payStatus,
  shippingStatus,
  activityBannerStatus,
  refundStatus,
  returnStatus,
  refundTypes,
}
